/**
 * Collection Load More / Infinite Scroll
 * Fetches next page HTML, extracts product cards, appends to grid.
 * Exposes window._reinitLoadMore() so collection-filter-ajax.js can call it
 * after a DOM swap.
 */
(function () {
  let loading = false;

  function getGrid() {
    return document.getElementById('collection-grid');
  }

  /**
   * Re-apply wishlist active states from localStorage
   */
  function initWishlistStates() {
    try {
      const list = JSON.parse(localStorage.getItem('af_wishlist')) || [];
      document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
        btn.classList.toggle('is-active', list.includes(btn.dataset.productHandle));
      });
    } catch (e) { /* ignore */ }
  }

  /**
   * Fetch next page and append products to grid
   */
  async function loadMore(nextUrl, trigger) {
    const grid = getGrid();
    if (loading || !nextUrl || !grid) return;
    loading = true;

    const btn = trigger.querySelector('[data-load-more-btn]');
    const spinner = trigger.querySelector('[data-load-more-spinner]');
    if (btn) { btn.classList.add('is-loading'); btn.textContent = 'Loading…'; }
    if (spinner) spinner.hidden = false;

    try {
      const res = await fetch(nextUrl);
      if (!res.ok) throw new Error('Fetch failed');
      const html = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newGrid = doc.getElementById('collection-grid');

      if (newGrid) {
        const cards = newGrid.querySelectorAll('.product-card');
        const fragment = document.createDocumentFragment();
        cards.forEach((card) => fragment.appendChild(card.cloneNode(true)));

        trigger.remove();
        grid.appendChild(fragment);

        const newLoadMore = newGrid.querySelector('[data-load-more]');
        if (newLoadMore) {
          const cloned = newLoadMore.cloneNode(true);
          grid.appendChild(cloned);
          // Update progress bar to reflect newly shown count
          const total  = parseInt(cloned.dataset.total, 10) || 0;
          const shown  = parseInt(cloned.dataset.shown, 10) || 0;
          const fill   = cloned.querySelector('.load-more__progress-fill');
          if (fill && total > 0) fill.style.width = Math.round(shown / total * 100) + '%';
          init();
        }

        initWishlistStates();
      }
    } catch (err) {
      console.error('[load-more]', err);
      if (btn) { btn.classList.remove('is-loading'); btn.textContent = 'Load more'; }
    } finally {
      loading = false;
    }
  }

  /**
   * Initialize load more / infinite scroll handlers on the current grid
   */
  function init() {
    const grid = getGrid();
    if (!grid) return;

    // Load More Button
    const loadMoreBtn = grid.querySelector('[data-load-more-btn]');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', () => {
        const trigger = loadMoreBtn.closest('[data-load-more]');
        loadMore(loadMoreBtn.dataset.nextUrl, trigger);
      });
    }

    // Infinite Scroll
    const sentinel = grid.querySelector('[data-load-more-sentinel]');
    if (sentinel) {
      const trigger = sentinel.closest('[data-load-more]');
      const nextUrl = sentinel.dataset.nextUrl;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !loading) {
              observer.disconnect();
              loadMore(nextUrl, trigger);
            }
          });
        },
        { rootMargin: '400px 0px' }
      );
      observer.observe(sentinel);
    }
  }

  // Expose reinit for collection-filter-ajax.js to call after DOM swaps
  window._reinitLoadMore = function () {
    loading = false;
    init();
  };

  init();
})();
